<template>
  <v-card class="main__light_green rounded-lg pa-8">
    <v-card-title class="pa-0 pb-1 h3-headline text-start tender-name-wrapper">
      <router-link :to=" {name: 'bidsHistoryByLots', params: { tenderId: tender.tenderId, org: $route.params.org, lotId: lot.lotId}} ">
        <span class="lot-name"> {{ lot.lotTitle || '–' }} </span>
      </router-link>
    </v-card-title>

    <v-card-text class=" pa-0 pt-5 flex-row d-flex ">
      <v-row
        justify="space-between"
        no-gutters>
        <v-col class="mr-3">
          <div class="h9-label px-0 pb-1">
            {{ $t('Catalog.Amount') }}
          </div>
          <div class="text-left h7-text black--text">
            {{ lot.quantity | formSum }}  {{ lot.unit ? lot.unit.title : '–' }}
          </div>
        </v-col>
        <v-col class="mr-3">
          <div class="h9-label px-0 pb-1">
            {{ $tc('Tenders.Proposals', 2 ) }}
          </div>
          <div
            class="text-left h7-text black--text">
            {{ lot.bidsAmount | formSum }}
          </div>
        </v-col>
        <v-col class="mr-3">
          <div class="h9-label px-0 pb-1">
            {{ $t('Tenders.NumberOfSuppliers') }}
          </div>
          <div
            class="text-left h7-text black--text">
            {{ lot.biddersAmount | formSum }}
          </div>
        </v-col>
        <template v-if="!($can('hide', 'PricesOnPrequalification') && tender.tenderStatus.id == 5)">
          <v-col class="mr-3">
            <div class="h9-label px-0 pb-1">
              {{ tender.biddingType.tenderingForPercentage ? $t('Tenders.StartingBid') : $t('Tenders.StartingBid') }}
            </div>
            <div class="text-left h7-text black--text">
              {{ lot.initialAmount | formSum }} {{ tender.biddingType.tenderingForPercentage ? '%': tenderCurrencyTitle }}
              <CurrencyConversionTooltip
                v-if="lot.initialAmount"
                :currency="tenderCurrencyTitle"
                :current-id="tenderCurrencyId"
                :price="lot.initialAmount"/>
            </div>
          </v-col>
          <v-col class="mr-3">
            <div class="h9-label px-0 pb-1">
              {{ tender.biddingType.tenderingForPercentage ? $t('Tenders.MinimumPercent') : $t('Tenders.MinimumPrice') }}
            </div>
            <div class="text-left h7-text black--text">
              {{ lot.minimalPriceCurrency | formSum }} {{ tender.biddingType.tenderingForPercentage ? '%': minimalBidCurrencyTitle }}
              <CurrencyConversionTooltip
                v-if="minimalBidCurrencyId !== 980"
                :currency="minimalBidCurrencyTitle"
                :current-id="minimalBidCurrencyId"
                :price="lot.minimalPriceCurrency"/>
            </div>
          </v-col>
          <v-col class="">
            <div class="h9-label px-0 pb-1">
              {{ tender.biddingType.tenderingForPercentage ? $t('Tenders.MaxPercent') : $t('Tenders.MaxPrice') }}
            </div>
            <div class="text-left h7-text black--text">
              {{ lot.maximumPriceCurrency | formSum }} {{ tender.biddingType.tenderingForPercentage ? '%': maximumBidCurrencyTitle }}
              <CurrencyConversionTooltip
                v-if="maximumBidCurrencyId !== 980"
                :currency="maximumBidCurrencyTitle"
                :current-id="maximumBidCurrencyId"
                :price="lot.maximumPriceCurrency"/>
            </div>
          </v-col>
        </template>
        <v-col
          align-self="end"
          class="d-flex align-end h7-text black--text justify-end"
          cols="1">
          <CancelledBidInfo :cancelled="cancelled"/>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>
<script>
import CancelledBidInfo from 'components/tenders/CancelledBidInfo.vue'
import CurrencyConversionTooltip from 'components/common/elements/CurrencyConversionTooltip.vue'

import moment from 'moment'
import { modalMixin } from 'mixins'

export default {
  name: 'bidHistoryLotCard',
  mixins: [modalMixin],
  props: {
    tender: Object,
    lot: Object
  },
  computed: {
    currencyId() {
      return this.lot.currency?.code ? this.lot.currency?.code : null
    },
    currencyTitle() {
      return this.lot.currency?.title ||  '–'
    },
    tenderCurrencyTitle() {
      return this.tender?.currency?.title || '–'
    },
    tenderCurrencyId() {
      return this.tender?.currency?.code ?? null
    },
    minimalBidCurrencyTitle() {
      return this.lot.minimalBidCurrency?.title || this.currencyTitle
    },
    minimalBidCurrencyId() {
      return this.lot.minimalBidCurrency?.code ?? this.currencyId
    },
    maximumBidCurrencyTitle() {
      return this.lot.maximumBidCurrency?.title || this.currencyTitle
    },
    maximumBidCurrencyId() {
      return this.lot.maximumBidCurrency?.code ?? this.currencyId
    },
    now() {
      return moment().format()
    },
    cancelled() {
      return this.lot.cancelledBidsCount
    }
  },
  components: {
    CancelledBidInfo,
    CurrencyConversionTooltip
  }
}
</script>
<style lang="scss">
.h9-label {
  width: max-content;
}

</style>
